module.exports = __webpack_public_path__ + "img/tu04.f95a3603.png";